import {useOutletContext} from "react-router-dom";
import {useEffect} from 'react';
import { APIDisplayNames, APINames, PAGE_TITLE_BASE, PageNames } from '../../Assets/variables';
import { apiInfos } from "../../Assets/API/apiInfos";
import APIPage from "../../Components/APIPage";
import {Helmet} from "react-helmet-async";

const MifidIICostAndCharges = () => {
    const {setActivePageItem} = useOutletContext();
    const apiInfo = apiInfos.filter(apiInfo => apiInfo.apiName === APINames.mifidIICostAndCharges)[0];
    
    useEffect(() => {
        setActivePageItem(PageNames.Catalog);
    }, []);
    
    return (
        <>
            <Helmet>
                <title>{`${PAGE_TITLE_BASE}${APIDisplayNames.MifidIICostAndCharges}`}</title>
                <meta name="description" content={`${apiInfo.description}`} />
                <link rel="canonical" href={`/${PageNames.Catalog}/${APINames.mifidIICostAndCharges}`} />
            </Helmet>
            <APIPage apiInfo={apiInfo} />
        </>
    );
};

export default MifidIICostAndCharges;